/* Forzly UpFlow theme JS: buy box, sticky bar, cart drawer with upsells. */
(function () {
  var FZ = window.FZ || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var v = (cents || 0) / 100;
    var s = new Intl.NumberFormat('en-US', { style: 'currency', currency: FZ.currency || 'USD' }).format(v);
    return s.replace(/\.00$/, '');
  }
  function tpl(id) { var t = document.getElementById(id); return t ? t.innerHTML : ''; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  /* Announcement rotator */
  $$('[data-ann]').forEach(function (el) {
    var track = $('.ann__track', el), n = track.children.length, i = 0;
    if (n < 2) return;
    setInterval(function () { i = (i + 1) % n; track.style.transform = 'translateX(' + (-100 * i) + '%)'; }, 4200);
  });

  /* Mobile menu */
  var menu = $('[data-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }); });
  $$('[data-menu] a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); }); });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.rv').forEach(function (el) { io.observe(el); });
  } else { $$('.rv').forEach(function (el) { el.classList.add('is-in'); }); }

  /* Gallery */
  $$('[data-gal]').forEach(function (g) {
    var slides = $('[data-gal-slides]', g); if (!slides) return;
    var thumbs = $$('[data-gal-thumb]', g), dots = $$('[data-gal-dots] i', g);
    function go(i) { var n = slides.children.length; i = (i + n) % n; slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); }
    function cur() { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); }
    slides.addEventListener('scroll', function () {
      var c = cur();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === c); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === c); });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.galThumb); }); });
    var p = $('[data-gal-prev]', g), n = $('[data-gal-next]', g);
    p && p.addEventListener('click', function () { go(cur() - 1); });
    n && n.addEventListener('click', function () { go(cur() + 1); });
  });

  /* Smooth anchor */
  $$('a[data-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); if (t.tagName === 'DETAILS') t.open = true; t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });

  /* ===== Cart API ===== */
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); });
  }

  /* ===== Buy box ===== */
  $$('[data-bb]').forEach(function (bb) {
    var sid = bb.dataset.bb;
    var cfgEl = document.querySelector('[data-bb-cfg="' + sid + '"]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    var tiers = $$('[data-tier]', bb), rows = $$('[data-size-row]', bb);
    var atc = $('[data-atc]', bb), label = $('[data-atc-label]', bb), ship = $('[data-ship-note]', bb);
    var sticky = document.querySelector('[data-sticky]');
    var stickyLabel = sticky && $('[data-sticky-label]', sticky);
    var qty = 1;

    function render() {
      var on = tiers.filter(function (t) { return +t.dataset.tier === qty; })[0];
      var price = on ? +on.dataset.price : 0;
      tiers.forEach(function (t) { var a = +t.dataset.tier === qty; t.classList.toggle('is-on', a); $('input', t).checked = a; });
      rows.forEach(function (r) { r.hidden = +r.dataset.sizeRow > qty; });
      var txt = (cfg.cta || 'Add to cart') + ' · ' + money(price);
      if (label && !atc.disabled) label.textContent = txt;
      if (stickyLabel) stickyLabel.textContent = txt;
      if (ship) ship.textContent = qty > 1 ? (cfg.ship2 || '') : (cfg.ship1 || '');
    }
    tiers.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); qty = +t.dataset.tier; render(); }); });
    rows.forEach(function (r) {
      $$('button[data-variant]', r).forEach(function (b) {
        b.addEventListener('click', function () { $$('button', r).forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on'); });
      });
    });

    function selection() {
      var map = {};
      rows.slice(0, qty).forEach(function (r) {
        var b = $('button.is-on', r) || $('button[data-variant]:not([disabled])', r);
        if (b) map[b.dataset.variant] = (map[b.dataset.variant] || 0) + 1;
      });
      return Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
    }
    function buy(btn) {
      var items = selection(); if (!items.length) return;
      btn.setAttribute('disabled', ''); var old = btn.innerHTML;
      btn.querySelector('span').textContent = 'Adding…';
      addItems(items).then(function () { return refreshCart(); }).then(function () { openDrawer(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); })
        .then(function () { btn.removeAttribute('disabled'); btn.innerHTML = old; render(); });
    }
    atc && atc.addEventListener('click', function () { buy(atc); });
    var sb = sticky && $('[data-sticky-btn]', sticky);
    sb && sb.addEventListener('click', function () { buy(sb); });

    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky');
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      }).observe(atc);
    }
    render();
  });

  /* ===== Drawer ===== */
  var drawer = $('[data-drawer]');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (document.body.classList.contains('tpl-cart')) return; e.preventDefault(); refreshCart().then(openDrawer); });
  });

  function heroQty(cart) {
    if (!FZ.hero) return 0;
    return cart.items.filter(function (i) { return i.product_id === FZ.hero.id; }).reduce(function (a, i) { return a + i.quantity; }, 0);
  }

  function renderCart(cart) {
    var hq = heroQty(cart);
    var bodyHtml = '', footHtml = '';
    if (!cart.item_count) {
      bodyHtml = '<div class="empty"><p class="h-m">Your cart is empty</p><p class="muted">Your legs are still waiting for their 20 minutes.</p><a class="btn" href="/products/' + (FZ.hero ? FZ.hero.handle : '') + '">Shop UpFlow Boots</a></div>';
    } else {
      var th = FZ.freeShip || 50000, sub = cart.total_price, pct = Math.min(100, Math.round(sub / th * 100));
      var msg = sub >= th ? '<b>Free shipping unlocked.</b> Nice.' :
        (hq === 1 ? 'Add a 2nd pair to unlock <b>free shipping</b> and save ' + money(2 * (FZ.tiers ? FZ.tiers[1] : 0) - (FZ.tiers ? FZ.tiers[2] : 0)) + '.' : 'You\'re <b>' + money(th - sub) + '</b> away from free shipping.');
      bodyHtml += '<div class="prog"><p>' + msg + '</p><div class="prog__bar"><i style="width:' + pct + '%"></i></div><div class="prog__marks"><span class="is-on">Cart</span><span class="' + (hq > 0 ? 'is-on' : '') + '">Free gifts</span><span class="' + (sub >= th ? 'is-on' : '') + '">Free shipping</span></div></div>';
      cart.items.forEach(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        bodyHtml += '<div class="li"><img src="' + img + '" alt="" loading="lazy"><div><div class="li__t">' + esc(it.product_title) + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="li__v">Size ' + esc(it.variant_title) + '</div>' : '') +
          '<div class="qty"><button type="button" data-q="' + it.key + '" data-v="' + (it.quantity - 1) + '" aria-label="Less">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + it.key + '" data-v="' + (it.quantity + 1) + '" aria-label="More">+</button></div>' +
          '<button class="li__rm" type="button" data-q="' + it.key + '" data-v="0">Remove</button></div><div class="li__p">' + was + money(it.final_line_price) + '</div></div>';
      });
      if (hq > 0 && FZ.gifts) {
        FZ.gifts.forEach(function (g) {
          bodyHtml += '<div class="gift"><span class="gift__ic">' + tpl('fz-ic-gift') + '</span><div><b>' + esc(g.title) + '</b><span>Free gift, packed with your boots</span></div><div class="gift__p">' + (g.value ? '<s>' + esc(g.value) + '</s>' : '') + 'FREE</div></div>';
        });
      }
      /* Upsells (offer brief: second pair at the 2x price, and the gel) */
      var ups = '';
      if (FZ.hero && hq > 0 && hq < 3 && FZ.tiers) {
        var line = cart.items.filter(function (i) { return i.product_id === FZ.hero.id; })[0];
        var add = FZ.tiers[hq + 1] - FZ.tiers[hq];
        var save = (hq + 1) * FZ.tiers[1] - FZ.tiers[hq + 1];
        var heroImg = line && line.image ? line.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        ups += '<div class="ups__card"><img src="' + heroImg + '" alt=""><div><b>' + (hq === 1 ? 'Add a 2nd pair for someone you love' : 'Make it the family pack') + '</b><span>Just ' + money(add) + ' more. You save ' + money(save) + ' in total' + (hq === 1 ? ' and get free shipping' : '') + '.</span><span class="ups__badge">Gift-ready</span></div>' +
          '<button class="btn" type="button" data-add="' + (line ? line.variant_id : FZ.hero.variants[0].id) + '">Add</button></div>';
      }
      if (FZ.upsell && !cart.items.some(function (i) { return i.variant_id === FZ.upsell.variant; })) {
        ups += '<div class="ups__card"><img src="' + (FZ.upsell.image || '') + '" alt=""><div><b>' + esc(FZ.upsell.title) + '</b><span>' + esc(FZ.upsell.pitch || '') + '</span><span class="ups__badge">' + money(FZ.upsell.price) + '</span></div>' +
          '<button class="btn" type="button" data-add="' + FZ.upsell.variant + '">Add</button></div>';
      }
      if (ups) bodyHtml += '<div class="ups"><p class="ups__t">Complete your evening ritual</p>' + ups + '</div>';

      var saved = cart.total_discount || 0;
      footHtml += (saved > 0 ? '<div class="tot-save"><span>You save</span><span>−' + money(saved) + '</span></div>' : '') +
        '<div class="tot"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
        '<p class="small">' + (cart.total_price >= (FZ.freeShip || 50000) ? 'Free shipping. Taxes at checkout.' : 'Shipping and taxes at checkout.') + '</p>' +
        '<form action="/cart" method="post"><button class="btn btn--xl btn--shine" type="submit" name="checkout">' + tpl('fz-ic-lock').replace('<svg', '<svg width="18" height="18"') + ' Secure checkout</button></form>' +
        '<div class="drw__trust"><span>' + tpl('fz-ic-moon') + '90-night trial</span><span>' + tpl('fz-ic-shield') + '3-year warranty</span></div>';
    }
    [['[data-cart-body]', '[data-cart-foot]'], ['[data-cart-page-body]', '[data-cart-page-foot]']].forEach(function (p) {
      var b = $(p[0]), f = $(p[1]);
      if (b) b.innerHTML = bodyHtml;
      if (f) f.innerHTML = footHtml;
    });
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count || ''; c.dataset.count = cart.item_count; });
  }

  function refreshCart() { return getCart().then(function (c) { renderCart(c); return c; }); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fs-cart-page-body], [data-fs-drawer]')) return; /* fs.js handles the /cart page and the fs drawer */
    var q = e.target.closest('[data-q]');
    if (q) { e.preventDefault(); q.disabled = true; changeLine(q.dataset.q, +q.dataset.v).then(renderCart); return; }
    var a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); a.disabled = true; a.textContent = '…'; addItems([{ id: +a.dataset.add, quantity: 1 }]).then(refreshCart).catch(function () { a.disabled = false; a.textContent = 'Add'; }); }
  });

  if ($('[data-cart-page-body]')) refreshCart();
  window.FZcart = { open: function () { refreshCart().then(openDrawer); }, refresh: refreshCart };
})();
